// 人工智能赛道（国内）完整赛题解析，内容依据 2026 年赛事通知整理。
export default {
  aiDomestic: {
    trackLabel: '人工智能赛道 · 赛题解析',
    title: '银行 AI 智能体',
    skipFirstParagraph: false,
    blocks: [
      { type: 'heading', text: '一、赛题背景' },
      { type: 'paragraph', text: '传统手机银行的操作路径长、功能入口深，用户完成一笔转账平均需要 3 步以上操作。随着多模态大模型和 Agent 技术的成熟，“说话就能办业务”正从概念走向现实。' },
      { type: 'paragraph', text: '本赛题要求参赛团队构建一个银行 AI 智能体（AI Banking Agent）：用户只需用自然语言描述需求，Agent 即可自主理解意图、规划任务链路，并在严格的安全框架内完成银行业务操作（可参考 OpenClaw 等开源智能体项目）。' },
      { type: 'paragraph', text: '行业对标：参考 Revolut AIR（Revolut 推出的 AI 银行助手）。鼓励参赛团队探索更深入的场景覆盖与更流畅的交互体验。' },
      { type: 'heading', text: '二、赛题任务' },
      { type: 'paragraph', text: '构建一个 AI Banking Agent 系统，通过自然语言对话理解用户金融意图，自主规划并执行银行业务操作，用户可通过 APP、IM 等渠道与 Agent 联通。参赛团队需至少覆盖以下 3 个核心场景（鼓励全覆盖），下表仅作参考：' },
      { type: 'table', rows: [
        ['序号', '场景方向', '典型能力示例'],
        ['1', '智能转账', '按人名 / 手机号 / 备注转账、定时转账、拆分 AA 收款'],
        ['2', '账单分析', '消费分类统计、异常交易识别、月度 / 年度账单报告'],
        ['3', '理财操作', '产品推荐与对比、风险评估、一键申购 / 赎回'],
        ['4', '卡片管理', '卡申请、额度调整、交易限制 / 解锁、卡片挂失'],
        ['5', '订阅 / 代扣管理', '自动识别订阅扣费、续费提醒、一键取消订阅'],
        ['6', '跨场景联动', '检测“我爱人生日”，当月锁定 1000 元活期，生日前 2 天订购鲜花、蛋糕']
      ] },
      { type: 'heading', text: '三、核心技术要求' },
      { type: 'heading', text: '1. 权限分级机制（实现优先级：高）' },
      { type: 'paragraph', text: '系统必须建立严格的操作权限分级体系，体现“低风险自动、高风险确认、极高风险强验证”的安全理念：' },
      { type: 'table', rows: [
        ['级别', '执行策略', '典型操作范围'],
        ['绿色', '自动执行', '余额查询、交易记录查询、账单分析、理财收益查询等纯查询类操作，Agent 确认意图后直接执行，无需二次确认'],
        ['黄色', '用户确认', '小额转账（日累计 ≤ 1000 元）、订阅查询 / 取消、虚拟卡申请等，执行前展示操作详情并获得明确确认'],
        ['红色', '强验证', '大额转账（日累计 > 1000 元）、密码修改、卡片挂失 / 解挂、理财产品申购等，须通过人脸识别、短信验证码或 U 盾等多因子认证']
      ] },
      { type: 'heading', text: '2. 安全机制（实现优先级：高）' },
      { type: 'paragraph', text: '幻觉防护：Agent 不得编造交易结果或账户信息；' },
      { type: 'paragraph', text: '注入防御：防止通过特殊 Prompt 绕过权限控制；' },
      { type: 'paragraph', text: '操作审计：所有关键操作需记录完整的决策链路与执行日志；' },
      { type: 'paragraph', text: '异常熔断：连续失败或可疑行为触发安全锁定；' },
      { type: 'paragraph', text: '沙箱环境：生成的代码在受限、可监控的逻辑隔离环境中运行。' },
      { type: 'heading', text: '3. 意图理解与任务规划' },
      { type: 'paragraph', text: '支持模糊表达、省略上下文、隐含意图的识别；复杂任务需拆解为有序的子任务 DAG（有向无环图）；执行过程中支持中断、回退和人工接管。' },
      { type: 'heading', text: '四、项目规范' },
      { type: 'paragraph', text: '参赛队伍须独立完成题目，符合相关法律法规规定，不得存在任何作弊、欺诈、侵犯他人知识产权等行为。参赛期间若经发现或被举报并核实存在上述行为，大赛组委会有权取消参赛队伍的参赛资格和比赛成绩。' },
      { type: 'paragraph', text: '本次大赛参赛作品的知识产权归参赛选手所有，主办方有权将参赛作品及作品相关信息、参赛队伍信息用于宣传品、相关出版物、指定及授权媒体发布、官方网站浏览及下载、展览（含巡展）等。' },
      { type: 'heading', text: '五、作品资料' },
      { type: 'paragraph', text: '1. 作品简介：前往大赛报名系统，提交作品名称并上传作品简介（200 字以内，内容包含创作理念及作品中所使用的 AI 技术等）。' },
      { type: 'paragraph', text: '2. 技术文档：系统架构图、核心算法说明、安全设计文档。' },
      { type: 'paragraph', text: '3. 答辩材料：答辩 PPT（汇报不超过 10 分钟）；演示视频（不超过 5 分钟）。' },
      { type: 'paragraph', text: '4. 作品信息：源代码，含 README、GitHub 仓库地址、部署说明、测试用例等。' },
      { type: 'paragraph', text: '5. 安全自评报告：权限分级实现说明及已知风险清单。' }
    ]
  }
}
